import * as Sentry from "@sentry/react";

export const ErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>Algo correu mal</h1>
        <p>Ocorreu um erro inesperado.</p>
        <button type="button" onClick={resetError}>
          Tentar novamente
        </button>
      </div>
    )}
  >
    {children}
  </Sentry.ErrorBoundary>
);
